import {
  ApplyCouponRuleIfExists,
  RemoveTicketsWithPasskeyRule
} from '../implementations';
import { Rule } from '../types/Rule';
import { RuleSetStrategy } from './RuleSetStrategy';

export class CartRuleSetStrategy implements RuleSetStrategy {
  getRules(): Rule[] {
    return [
      new ApplyCouponRuleIfExists(),
      new RemoveTicketsWithPasskeyRule()
    ];
  }
}
